module.exports = __webpack_public_path__ + "img/poter4.40bb1a5d.jpg";